import { createApp, defineAsyncComponent } from "vue";
import vue3GoogleLogin from "vue3-google-login";
import VueAxios from "vue-axios";
import axios from "axios";
import "./registerServiceWorker";

import { store } from "@/store";
import MainLoading from "@/components/MainLoading.vue";

// App component
const AddOn = defineAsyncComponent({
  // the loader function
  loader: () => import("./AddOn.vue"),

  // A component to use while the async component is loading
  loadingComponent: MainLoading,
  // Delay before showing the loading component. Default: 200ms.
  delay: 0,

  // // A component to use if the load fails
  // errorComponent: ErrorComponent,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
  timeout: 1000,
});
// Plugins and package
import InlineSvg from "vue-inline-svg";

// Add Styles To Application
import "@/assets/scss/styles.scss";
import { handleRootThemeMode } from "@/utils/share";

// Add Bootstrap to Application
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap";

const app = createApp(AddOn);

// Global components
app.component("InlineSvg", InlineSvg);
// Global directives
app.directive("focus", {
  // When the bound element is mounted into the DOM...
  mounted(el) {
    // Focus the element
    el.focus();
  },
});

// Init Dark/Light mode from local storage
const value = localStorage.getItem("data") || null;
if (value) {
  const ls = JSON.parse(value);
  const isDarkMode = ls?.settings?.isDarkMode;
  if (isDarkMode) {
    handleRootThemeMode("dark");
  } else {
    handleRootThemeMode("light");
  }
}

// Global Plugins
app.use(vue3GoogleLogin, {
  clientId: process.env.VUE_APP_CLIENT_ID || "",
  scopes: [
    "https://www.googleapis.com/auth/drive",
    "https://www.googleapis.com/auth/userinfo.profile",
  ],
});
app.use(store);
app.use(VueAxios, axios);
// Inject component to App
app.mount("#app");
